"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.symbol");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Theme = require("../Theme");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var variants = {
  light: 'fal',
  regular: 'far',
  solid: 'fas'
}; // eslint-disable-next-line object-curly-newline

var Icon = function Icon(_ref) {
  var name = _ref.name,
      color = _ref.color,
      size = _ref.size,
      variant = _ref.variant,
      rounded = _ref.rounded,
      style = _ref.style,
      className = _ref.className,
      forwardedRef = _ref.forwardedRef,
      rest = _objectWithoutProperties(_ref, ["name", "color", "size", "variant", "rounded", "style", "className", "forwardedRef"]);

  var content = _react["default"].createElement("i", {
    ref: forwardedRef,
    className: "".concat(variants[variant], " fa-").concat(name, " ").concat(rounded ? '' : className),
    style: Object.assign({
      color: color,
      fontSize: "".concat(size, "px")
    }, style || {})
  });

  if (rounded) {
    return _react["default"].createElement(Span, Object.assign({
      ref: forwardedRef,
      size: size,
      color: color,
      className: className
    }, rest), content);
  }

  return content;
};

Icon.propTypes = {
  name: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  color: _propTypes["default"].string,
  rounded: _propTypes["default"].bool,
  variant: _propTypes["default"].string,
  size: _propTypes["default"].number,
  style: _propTypes["default"].object
};
Icon.defaultProps = {
  rounded: false,
  variant: 'light',
  color: _Theme.colors.primary,
  className: '',
  size: 24,
  style: {}
};

var Span = _styledComponents["default"].span.withConfig({
  displayName: "Icon__Span",
  componentId: "sc-3s68zh-0"
})(["width:", "px;height:", "px;border-radius:50%;border:1px solid ", ";display:flex;justify-content:center;align-items:center;.fa,.fas,.fal,.far{line-height:", "px;}"], function (props) {
  return props.size * 2;
}, function (props) {
  return props.size * 2;
}, function (props) {
  return props.color;
}, function (props) {
  return props.size;
});

var _default = _react["default"].forwardRef(function (props, ref) {
  return _react["default"].createElement(Icon, Object.assign({}, props, {
    forwardedRef: ref
  }));
});

exports["default"] = _default;